import { useEffect } from "react";
import useCustomQuery from "../../Common/hooks/useCustomQuery";
import { RTN_interface } from "../../Common/interface/App.interface";
import { callAxios, customToast, dev_console, setQueryParameter } from "../../Common/ts/commonTools";
import { detailThemeBookProduct_Interface } from "../interface/detailThemeBookProduct.interface";
import { AxiosResponse } from "axios";
import { defaultApiReaponseResult_Interface, defaultApiReaponseStatusVersion2_Interface } from "../../Common/interface/Common.interface";

export function useDetailThemeBookProductREST(
    {
        brand_id,
        detail_product_option_id,
    }:{
        brand_id: number;
        detail_product_option_id: number;
    }
) {
    function isAbleToRequest(){
        let RTN: boolean = false;

        if(brand_id && detail_product_option_id){
            RTN = true;
        }

        return RTN;
    }

    const {
        data: detailThemeBookProductData = null,
        isLoading: detailThemeBookProductIsLoading,
        error: detailThemeBookProductError,
        refetch: detailThemeBookProductRefetch,
    } = useCustomQuery({
        queryKey: ["useDetailThemeBookProductREST", brand_id, detail_product_option_id],
        queryFn: getDetailThemeBookProduct,
        enabled: isAbleToRequest,
        select: (response) => {
            let RTN: detailThemeBookProduct_Interface | null = null;

            if(response.status !== 200){
                throw new Error("제품 상세정보를 요청하는 과정에서 문제가 발생했습니다.");
            }

            if(!response.data){
                throw new Error("응답 data 객체가 없습니다.");
            }

            if(!response.data.result){
                throw new Error("reuslt 데이터가 없습니다.");
            }

            const result = response.data.result as defaultApiReaponseResult_Interface<detailThemeBookProduct_Interface[]>;

            if(!result.data || result.data.length === 0){
                throw new Error("데이터가 없습니다.");
            }

            RTN = result.data[0];

            return RTN;
        },
    })

    async function getDetailThemeBookProduct(){
        const base_url = "api/v3/detail-product/option/list";
        const query_parameter_string = setQueryParameter([
            {
                key: "brand_id",
                value: brand_id.toString(),
            },
            {
                key: "detail_product_option_id",
                value: detail_product_option_id.toString(),
            },
        ]);

        const url = base_url.concat("?", query_parameter_string);

        const response = await callAxios.api({
            url: url,
            method: "get",
        });

        dev_console.log("url ===>", url);
        dev_console.log("response ===>", response);

        return response;
    }

    useEffect(() => {
        if(detailThemeBookProductError){
            customToast.error({
                msg: "제품 상세정보를 요청하는 과정에서 문제가 발생했습니다.",
                toastId: "useDetailProductREST_error",
            })
            dev_console.error(detailThemeBookProductError);
        }
    }, [detailThemeBookProductError])

    return({
        detailThemeBookProductData,
        detailThemeBookProductError,
        detailThemeBookProductIsLoading,
        detailThemeBookProductRefetch,
    })
}